/**
 * メガバイト.
 *
 * @type {number}
 */
export const megabyte = 1024 * 1024;

/**
 * ギガバイト.
 *
 * @type {number}
 */
export const gigabyte = 1024 * 1024 * 1024;

/**
 * アップロード閾値.
 *
 * @type {number}
 */
export const uploadThreshold = 100 * megabyte;

/**
 * 分割したBlobを取得する.
 *
 * @type {function}
 */
export const getSliceBlob = (index, file, chunkSize, chunkNumber) => {
  const start = (index - 1) * chunkSize;
  const end = index * chunkSize;
  if (index < chunkNumber) {
    return file.slice(start, end);
  }
  return file.slice(start);
};

/**
 * FileReaderPromiseクラス
 */
// export default class FileReaderPromise extends FileReader{

//   readAs(blob, ctx){
//     return new Promise((res, rej)=>{
//       super.addEventListener("load", ({target}) => res(target.result));
//       super.addEventListener("error", ({target}) => rej(target.error));
//       super[ctx](blob);
//     });
//   }

//   readAsArrayBuffer(blob){
//     return this.readAs(blob, "readAsArrayBuffer");
//   }

//   readAsDataURL(blob){
//     return this.readAs(blob, "readAsDataURL");
//   }

//   readAsText(blob){
//     return this.readAs(blob, "readAsText");
//   }
// }

/**
 * ファイル名をチェック
 *
 * @type {function}
 */
export const isFileFolderName = (name) => {
  // eslint-disable-next-line no-useless-escape
  const checkStr = /^.*[(\\|/|:|\*|?|\"|<|>|\||\{|\}|^|%|`|\[|\]|~|#|\')].*$/;
  const result = name.match(checkStr);
  if (result === null) {
    return true;
  }
  return false;
};
